/**
 * Created by razial on 25.03.2025.
 */

const RepairLocation = function (locationConfig, slot) {
    cleverapps.EventEmitter.call(this);

    this.slot = slot;

    this.locationConfig = locationConfig;
    this.locationId = locationConfig.locationId;

    this.continuousStageByRoom = [];
    this.daysByRoom = [];
    for (let roomNo = 0, continuousStage = 0; roomNo < this.getTotalRooms(); roomNo++) {
        this.continuousStageByRoom.push([]);

        for (let buildingNo = 0; buildingNo < this.getBuildingsInRoom(roomNo); buildingNo++) {
            this.continuousStageByRoom[roomNo].push(continuousStage);
            continuousStage += bundles[`building_${roomNo}_${buildingNo}`].meta.stages;
        }
        this.continuousStageByRoom[roomNo].push(continuousStage);

        this.daysByRoom.push(this.splitRoomByDays(roomNo, this.continuousStageByRoom[roomNo][this.getBuildingsInRoom(roomNo)] - this.continuousStageByRoom[roomNo][0]));
    }

    this.roomNo = this.slot.load("room") || 0;
    this.buildingNo = this.slot.load("building") || 0;
    this.stageNo = this.slot.load("stage") || 0;

    this.normalizeProgress();

    this.stars = new OrderStars(this.slot);

    this.logEvents();

    this.config = bundles.repair_config.jsons.repair_config_json.resolve().getJson();
    this.rewardsForFixes = this.config.rewardsForFixes;
    this.stagesProgress = this.config.stagesProgress;
};

RepairLocation.prototype = Object.create(cleverapps.EventEmitter.prototype);
RepairLocation.prototype.constructor = RepairLocation;

RepairLocation.prototype.normalizeProgress = function () {
    const totalRooms = this.getTotalRooms();

    if (this.roomNo >= totalRooms) {
        this.roomNo = totalRooms - 1;
        this.buildingNo = this.getBuildingsInRoom(this.roomNo);
        this.stageNo = 0;
        return;
    }

    while (this.buildingNo < this.getBuildingsInRoom(this.roomNo)
        && this.stageNo >= this.getStagesInBuilding(this.buildingNo)) {
        this.buildingNo++;
        this.stageNo = 0;
    }
};

RepairLocation.prototype.gamePlayed = function (game) {
    if (game.outcome !== GameBase.OUTCOME_VICTORY) {
        return;
    }

    game.rewards.orderStar = 10;

    cleverapps.user.incPhysicalLevel();
};

RepairLocation.prototype.tillEndLocationStars = function () {
    if (this.isRoomCompleted()) {
        return 0;
    }

    return this.stagesProgress
        .slice(this.getCurrentStage(), this.getStagesInBuilding())
        .reduce((sum, stage, index) => sum + this.calcStarsForStage(this.getCurrentStage() + index), 0);
};

RepairLocation.prototype.clearAnimations = function () {
};

RepairLocation.prototype.displayNewTaskWindow = function () {
    if (this.isLocationCompleted()) {
        cleverapps.centerHint.createTextHint(Messages.get("RepairLocation.ComingSoonHint"));
        return;
    }

    cleverapps.focusManager.display({
        focus: "NewTaskWindow",
        stack: true,
        action: (f) => {
            this.trigger("taskWindowShown");

            new NewTaskWindow();

            cleverapps.focusManager.onceNoWindowsListener = () => {
                f();
                this.trigger("taskWindowHidden");
            };
        }
    });
};

RepairLocation.prototype.buyNextStage = function () {
    const price = this.calcStarsForStage();

    if (!this.stars.canTakeStars(price)) {
        return;
    }

    this.stars.takeStars(price);

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.LOCATION_FIX}_${this.roomNo}_${this.buildingNo}_${this.stageNo}`);
    this.setStage(this.stageNo + 1);

    if (this.buildingNo === this.getBuildingsInRoom() - 1 && this.isBuildingCompleted()) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.ROOM_COMPLETED, { itemId: `${this.roomNo}`, value: this.getTotalRooms() });
    }

    this.logEvents();
};

RepairLocation.prototype.showStageDialogue = function (data, f) {
    cleverapps.focusManager.hideAllControls();

    const dialogue = new Dialogue(data, {
        autoClose: true,
        autoScroll: false,
        showUp: true
    });

    dialogue.on("afterClose", () => {
        f();

        cleverapps.timeouts.setTimeout(f, 500);
    });

    new DialogueView(dialogue);
};

RepairLocation.prototype.animateNextStage = function () {
    const previousStage = this.stageNo - 1;

    const actions = [
        (f) => this.trigger("beforeNextStage", cleverapps.waiter(f)),

        (f) => this.trigger("scrollToRepair", previousStage, f),

        (f) => {
            this.trigger("animateProgress");
            this.trigger("nextStage", f);
        },

        (f) => this.trigger("scrollToRepair", this.stageNo, f),

        (f) => {
            if (this.needMoveNextBuilding()) {
                this.moveNextBuilding(f);
            } else {
                f();
            }
        },

        (f) => this.trigger("afterNextStage", cleverapps.waiter(f)),

        (f) => {
            cleverapps.eventBus.trigger("garden_fix");
            setTimeout(() => {
                cleverapps.tutorial.trigger("roomRepairFinish");
            }, 10);
            f();
        }
    ];

    cleverapps.focusManager.display({
        focus: "buyNextStage",
        stack: true,
        actions
    });
};

RepairLocation.prototype.updateRoom = function (f) {
    cleverapps.meta.gotoLocationScene(f);
};

RepairLocation.prototype.changeRoom = function (roomNo) {
    this.roomNo = roomNo;
    this.slot.save("room", this.roomNo);

    this.openInMetaMode = true;

    this.changeBuilding(0);

    connector.conversions.trackEvent(cleverapps.EVENTS.CONVERSIONS.ROOM_CHANGE);

    if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 18, 20, 23, 26, 30, 35, 40, 45, 50].includes(roomNo)) {
        connector.conversions.trackEvent(cleverapps.EVENTS.CONVERSIONS.ROOM_REACH + roomNo);
    }
};

RepairLocation.prototype.changeBuilding = function (buildingNo) {
    if (buildingNo < 0 || buildingNo > this.getBuildingsInRoom(this.roomNo)) {
        return;
    }

    this.buildingNo = buildingNo;
    this.setStage(0);

    this.slot.save("building", this.buildingNo);
    this.logEvents();
};

RepairLocation.prototype.reset = function () {
    this.slot.reset();
    this.changeBuilding(0);
    this.setStage(0);
    this.trigger("reset", this.stageNo);
};

RepairLocation.prototype.setStage = function (stage) {
    this.stageNo = stage;

    this.slot.save("stage", this.stageNo);

    cleverapps.meta.trigger("progressChanged");
    cleverapps.user.trigger("recheckAvailable");
};

RepairLocation.prototype.isLastRoom = function () {
    return this.roomNo === this.getTotalRooms() - 1;
};

RepairLocation.prototype.getCurrentRoom = function () {
    return this.roomNo;
};

RepairLocation.prototype.getTotalRooms = function () {
    if (this.totalRooms !== undefined) {
        return this.totalRooms;
    }

    let totalRooms = 0;

    while (this.getRoomBundleId(totalRooms) !== "room_unknown" && (!bundles[this.getRoomBundleId(totalRooms)].meta.debug || cleverapps.config.debugMode)) {
        totalRooms++;
    }

    this.totalRooms = totalRooms;

    return this.totalRooms;
};

RepairLocation.prototype.getCurrentStage = function () {
    return this.stageNo;
};

RepairLocation.prototype.getCurrentBuilding = function () {
    return this.buildingNo;
};

RepairLocation.prototype.getBuildingsInRoom = function (roomNo) {
    if (roomNo === undefined) {
        roomNo = this.roomNo;
    }

    return bundles[this.getRoomBundleId(roomNo)].meta.stages;
};

RepairLocation.prototype.getBuildingBundle = function (buildingNo) {
    if (buildingNo >= this.getBuildingsInRoom(this.roomNo)) {
        return bundles[`building_${this.roomNo}_soon`];
    }

    return bundles[`building_${this.roomNo}_${buildingNo}`];
};

RepairLocation.prototype.getBuildingJson = function (buildingNo) {
    const bundle = this.getBuildingBundle(buildingNo);
    if (buildingNo >= this.getBuildingsInRoom(this.roomNo)) {
        return bundle.jsons[`building_${this.roomNo}_soon`];
    }

    return bundle.jsons[`building_${this.roomNo}_${buildingNo}`];
};

RepairLocation.prototype.getStagesInBuilding = function (buildingNo) {
    if (buildingNo === undefined) {
        buildingNo = this.buildingNo;
    }
    return bundles[`building_${this.roomNo}_${buildingNo}`].meta.stages;
};

RepairLocation.prototype.isCompleted = function () {
    return false;
};

RepairLocation.prototype.isLocationCompleted = function () {
    return this.isRoomCompleted() && this.isLastRoom();
};

RepairLocation.prototype.isRoomCompleted = function () {
    return this.buildingNo >= this.getBuildingsInRoom(this.roomNo);
};

RepairLocation.prototype.isBuildingCompleted = function () {
    return this.stageNo >= this.getStagesInBuilding();
};

RepairLocation.prototype.logEvents = function () {
    if (this.isLocationCompleted()) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.PASS_ALL_LOCATIONS);
    }
};

RepairLocation.prototype.getProgress = function () {
    if (this.isRoomCompleted()) {
        return 100;
    }

    const stages = this.continuousStageByRoom[this.roomNo][this.buildingNo] - this.continuousStageByRoom[this.roomNo][0] + this.stageNo;

    let totalStages = 0;
    for (let i = 0; i < this.getBuildingsInRoom(); i++) {
        totalStages += bundles[`building_${this.roomNo}_${i}`].meta.stages;
    }

    if (totalStages === 0) {
        return 0;
    }

    return stages / totalStages * 100;
};

RepairLocation.prototype.getBuildingProgress = function () {
    if (this.isBuildingCompleted()) {
        return 100;
    }

    const totalStages = this.getStagesInBuilding();

    if (totalStages === 0) {
        return 0;
    }

    return this.stageNo / totalStages * 100;
};

RepairLocation.prototype.moveNextRoom = function () {
    cleverapps.focusManager.display({
        focus: "repairMoveNextRoom",
        actions: [
            (f) => {
                new TravelMapWindow({ animateNext: true });
                cleverapps.focusManager.onceNoWindowsListener = f;
            },
            (f) => {
                this.changeRoom(this.roomNo + 1);
                this.updateRoom(f);
            }
        ]
    });
};

RepairLocation.prototype.needMoveNextBuilding = function () {
    return this.buildingNo < this.getBuildingsInRoom(this.roomNo) && this.isBuildingCompleted();
};

RepairLocation.prototype.moveNextBuilding = function (f) {
    this.changeBuilding(this.buildingNo + 1);
    this.trigger("moveNextBuilding", cleverapps.waiter(f));
};

RepairLocation.prototype.getContinuousStage = function (stage) {
    if (stage === undefined) {
        stage = this.getCurrentStage();
    }

    if (this.isLocationCompleted()) {
        return this.continuousStageByRoom[this.roomNo][this.getBuildingsInRoom() - 1];
    }

    return this.continuousStageByRoom[this.roomNo][this.buildingNo] + stage;
};

RepairLocation.prototype.parseContinuousStage = function (continuousStage) {
    let stage = continuousStage;

    for (let roomNo = 0; roomNo < this.getTotalRooms(); roomNo++) {
        for (let buildingNo = 0; buildingNo < this.getBuildingsInRoom(roomNo); buildingNo++) {
            const stagesInBuilding = bundles[`building_${roomNo}_${buildingNo}`].meta.stages;

            if (stage < stagesInBuilding) {
                return { stageNo: stage, buildingNo, roomNo };
            }

            stage -= stagesInBuilding;
        }
    }
};

RepairLocation.prototype.splitRoomByDays = function (roomNo, fixes) {
    if (cleverapps.config.features.includes("island_repair")) {
        return this.splitIslandByDays(roomNo, fixes);
    }

    const days = RepairLocation.ROOM_DAYS;
    const perDay = Math.floor(fixes / days);
    const extra = fixes - perDay * days;

    const result = [];
    for (let day = 0; day < days; day++) {
        result.push(perDay + (day < extra ? 1 : 0));
    }
    return result;
};

RepairLocation.prototype.splitIslandByDays = function (roomNo, fixes) {
    const { min, max } = RepairLocation.ISLAND_DAY_FIXES;

    if (fixes <= min) {
        return [fixes];
    }

    const days = cleverapps.clamp(Math.round(fixes / ((min + max) / 2)), Math.ceil(fixes / max), Math.floor(fixes / min));
    const result = new Array(days).fill(min);

    const random = new PseudoRandom(`repair_days_${roomNo}`);
    const notFull = result.map((dayFixes, day) => day);

    for (let left = fixes - min * days; left > 0; left--) {
        const day = random.choose(notFull);
        result[day]++;

        if (result[day] >= max && notFull.length > 1) {
            notFull.splice(notFull.indexOf(day), 1);
        }
    }

    return result;
};

RepairLocation.prototype.getDayInfo = function (continuousStage) {
    if (continuousStage === undefined) {
        continuousStage = this.getContinuousStage();
    }

    let dayNo = 0;
    let start = 0;
    let fixes = 0;

    for (let roomNo = 0; roomNo < this.daysByRoom.length; roomNo++) {
        const days = this.daysByRoom[roomNo];

        for (let index = 0; index < days.length; index++) {
            dayNo++;
            start = this.continuousStageByRoom[roomNo][0] + days.slice(0, index).reduce((sum, dayFixes) => sum + dayFixes, 0);
            fixes = days[index];

            if (continuousStage < start + fixes) {
                return {
                    dayNo, fixes, start, done: continuousStage - start
                };
            }
        }
    }

    return {
        dayNo, fixes, start, done: fixes
    };
};

RepairLocation.prototype.getRewardsForFix = function (stage) {
    let rewards = [{ exp: this.getExpForFix() }];
    if (this.rewardsForFixes[this.getContinuousStage(stage)]) {
        rewards = rewards.concat(this.rewardsForFixes[this.getContinuousStage(stage)]);
    }
    return rewards;
};

RepairLocation.prototype.getTotalRewardsForFix = function () {
    const rewards = [];
    for (let i = 0; i < this.getContinuousStage(); i++) {
        const reward = this.rewardsForFixes[i];
        if (reward) {
            rewards.push(reward);
        }
    }
    return rewards.flat();
};

RepairLocation.prototype.getRoomBundleId = function (roomNo) {
    return bundles[`room_${roomNo}`] ? `room_${roomNo}` : "room_unknown";
};

RepairLocation.prototype.listBundles = function () {
    const buildingsBundles = [];
    let index = 0;
    while (bundles[`island_buildings_${this.roomNo}_${index}`]) {
        if (!bundles[`island_buildings_${this.roomNo}_${index}`].virtual) {
            buildingsBundles.push(`island_buildings_${this.roomNo}_${index}`);
        }
        index++;
    }
    return [this.getRoomBundleId(this.getCurrentRoom()), ...buildingsBundles];
};

RepairLocation.prototype.calcStarsForStage = function (stage) {
    stage = stage !== undefined ? stage : this.getContinuousStage();
    return this.stagesProgress[stage];
};

RepairLocation.prototype.checkAvailable = function (available) {
    return !available.fix || this.getContinuousStage() >= available.fix;
};

RepairLocation.prototype.calcTaskText = function () {
    const key = `NewTaskWindow.Task.${this.roomNo}.${this.buildingNo}.${this.stageNo}`;
    if (Messages.has(key)) {
        return key;
    }

    const fallback = `NewTaskWindow.Task.${this.roomNo}.${this.buildingNo}`;
    if (Messages.has(fallback)) {
        return fallback;
    }

    const continuousKey = `NewTaskWindow.Task.${this.getContinuousStage()}`;
    if (Messages.has(continuousKey)) {
        return continuousKey;
    }

    return "NewTaskWindow.Task.default";
};

RepairLocation.prototype.isFirstFix = function () {
    return this.roomNo === 0 && this.buildingNo === 0 && this.stageNo === 0;
};

RepairLocation.prototype.getExpForFix = function () {
    return 10;
};

RepairLocation.ROOM_DAYS = 3;
RepairLocation.ISLAND_DAY_FIXES = { min: 8, max: 12 };

RepairLocation.GetMainScene = function () {
    if (cleverapps.config.type === "merge2") {
        return bundles.main.jsons.merge2scene_prefab_json;
    }

    return bundles.main.jsons.repairscene_prefab_json;
};
